export enum INTERVIEW_STATES{
  NOT_AVAILABLE,
  FAILED,
  AVAILABLE,
  SCHEDULED,
  COMPLETED,
}
